import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#043351',
                secondary: '#f36e21',
                color_gray: '#454f5b',
            },
        },
        options: { customProperties: true },
    },
});
